import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/profile.jpg";

interface UserData {
    id: number;
    username: string;
    email: string;
    role: boolean;
    isActive: boolean;
    lastLogin: string;
    createdAt: string;
    updatedAt: string;
}

const ProfileDropdown = () => {
    const [userData, setUserData] = useState<UserData | null>(null);
    const [userName, setUserName] = useState("Admin");
    const [userRole, setUserRole] = useState("");
    const [userEmail, setUserEmail] = useState("");

    useEffect(() => {
        // Get user data from localStorage
        const userDataString = localStorage.getItem("user");
        
        if (userDataString) {
            try {
                const user: UserData = JSON.parse(userDataString);
                setUserData(user);
                
                // Set username - fallback to email if username not available
                setUserName(user.username || user.email || "Admin");
                
                // Set email
                setUserEmail(user.email || "");
                
                // Set user role - true means admin, false means staff
                setUserRole(user.role ? "Admin" : "Staff");
                
            } catch (error) {
                console.error("Error parsing user data:", error);
                setUserName("Admin");
                setUserRole("");
                setUserEmail("");
            }
        } else {
            // Fallback if no user data in localStorage
            setUserName("Admin");
            setUserRole("");
            setUserEmail("");
        }
    }, []); // Empty dependency array means this runs once on mount

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown 
                isOpen={isProfileDropdown} 
                toggle={toggleProfileDropdown} 
                className="ms-sm-3 header-item topbar-user"
            >
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img 
                            className="rounded-circle header-profile-user" 
                            src={avatar1}
                            alt="Header Avatar" 
                        />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                {userName}
                            </span>
                            <span className="d-none d-xl-inline-block ms-1 text-muted user-role-text">
                                ({userRole})
                            </span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">
                        Welcome, {userName}!
                        <span className="d-block text-muted small mt-1">{userEmail}</span>
                        <span className="d-block text-muted small">
                            Role: <span className="badge bg-primary-subtle text-primary">{userRole}</span>
                        </span>
                    </h6>
                    
                    <DropdownItem className='p-0'>
                        <Link to="/profile-setting" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">My Profile</span>
                        </Link>
                    </DropdownItem>
                    
                    {/* <DropdownItem className='p-0'>
                        <Link to="/profile-setting" className="dropdown-item">
                            <span className="badge bg-success-subtle text-success mt-1 float-end">New</span>
                            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Settings</span>
                        </Link>
                    </DropdownItem> */}
                    
                    <div className="dropdown-divider"></div>
                    
                    <DropdownItem className='p-0'>
                        <Link
                            to="/logout"
                            className="dropdown-item dropdown-item-red-hover"
                        >
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;